import { render, staticRenderFns } from "./MultiLangCategoryMaintain.vue?vue&type=template&id=1f0f3962&scoped=true"
import script from "./MultiLangCategoryMaintain.vue?vue&type=script&lang=js"
export * from "./MultiLangCategoryMaintain.vue?vue&type=script&lang=js"
import style0 from "./MultiLangCategoryMaintain.vue?vue&type=style&index=0&id=1f0f3962&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0f3962",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/muying-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f0f3962')) {
      api.createRecord('1f0f3962', component.options)
    } else {
      api.reload('1f0f3962', component.options)
    }
    module.hot.accept("./MultiLangCategoryMaintain.vue?vue&type=template&id=1f0f3962&scoped=true", function () {
      api.rerender('1f0f3962', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/i18n/MultiLangCategoryMaintain.vue"
export default component.exports